export default {
    // 前一个路由
    previousRoute: ""

}